import React from "react";
import { Modal } from "@components";
import { DialogContent, Box, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import type { DoctorDocumentReadinessModalProps } from "@hooks/useDoctorDocumentReadiness";
import {
  IDENTITY_VALIDATION_ROUTE,
  ValidationRequiredModal,
} from "./ValidationRequiredModal";

const TextContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  gap: 16,
});

const BoldSpan = styled("span")({
  fontWeight: 600,
});

export const DoctorDocumentReadinessModal: React.FC<
  DoctorDocumentReadinessModalProps
> = ({ missing, onClose, requestId, redirectTo }) => {
  const navigate = useNavigate();

  if (!missing) return null;

  const goToAddress = () =>
    navigate("/app/datos-personales/cambiar-direccion", {
      state: { redirectTo },
    });

  const goToFeaEnrolment = () =>
    navigate(IDENTITY_VALIDATION_ROUTE, {
      state: { requestId },
    });

  if (missing.address && missing.fea) {
    return (
      <Modal
        title="Completa tu perfil para emitir documentos"
        isOpen
        onClose={onClose}
        buttonProps={{
          buttonText: "Agregar dirección",
          onClick: goToAddress,
        }}
      >
        <DialogContent style={{ padding: "16px 0px" }}>
          <TextContainer>
            <div>
              Necesitamos dos datos antes de emitir documentos: la{" "}
              <BoldSpan>dirección de tu lugar de atención</BoldSpan> y la{" "}
              <BoldSpan>verificación de tu identidad</BoldSpan>.
            </div>
          </TextContainer>
        </DialogContent>
      </Modal>
    );
  }

  if (missing.address) {
    return (
      <Modal
        title="Agrega tu dirección de consulta"
        isOpen
        onClose={onClose}
        buttonProps={{
          buttonText: "Agregar dirección",
          onClick: goToAddress,
        }}
      >
        <DialogContent style={{ padding: "16px 0px" }}>
          <TextContainer>
            <div>
              Necesitamos esta información para incluirla en el documento, como
              exige la normativa.
            </div>
          </TextContainer>
        </DialogContent>
      </Modal>
    );
  }

  if (missing.bpoValidation) {
    return <ValidationRequiredModal isOpen onClose={onClose} />;
  }

  return (
    <Modal
      title="Verificación"
      isOpen
      onClose={onClose}
      buttonProps={{
        buttonText: "Continuar",
        onClick: goToFeaEnrolment,
      }}
    >
      <DialogContent style={{ padding: "16px 0px" }}>
        <TextContainer>
          <div>
            Para emitir tu <BoldSpan>primer documento médico</BoldSpan>{" "}
            necesitamos verificar tu identidad en 3 pasos
          </div>
          <div>
            Este proceso se hace <BoldSpan>una sola vez</BoldSpan>
          </div>
        </TextContainer>
      </DialogContent>
    </Modal>
  );
};
